import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SesionService } from './sesion.service';
import { ContextoTenantStore } from './contexto-tenant.store';

export const authGuard: CanActivateFn = async (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const sesion = inject(SesionService);
    const token = await auth.getValidAccessToken();
    if (!token) return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    try {
        if (!(await auth.isEmailVerified())) {
            return router.createUrlTree(['/auth/verify-email'], { queryParams: { returnUrl: state.url } });
        }
        const actual = await sesion.cargar();
        const sinAccesos = !actual.administradorplataforma && actual.permisos.length === 0;
        if (sinAccesos && !state.url.startsWith('/sin-acceso')) return router.createUrlTree(['/sin-acceso']);
        if (!sinAccesos && state.url.startsWith('/sin-acceso')) return router.createUrlTree(['/']);
        return true;
    } catch {
        return router.createUrlTree(['/auth/access']);
    }
};

export const permisoGuard: CanActivateFn = async (route) => {
    const router = inject(Router);
    const sesion = inject(SesionService);
    const contexto = inject(ContextoTenantStore);
    try {
        await sesion.cargar();
        const permiso = route.data?.['permiso'] as string | undefined;
        const permisos = route.data?.['permisos'] as string[] | undefined;
        const plataforma = route.data?.['plataforma'] === true;
        const autorizado = plataforma ? contexto.administradorplataforma() : permisos?.length ? permisos.some((codigo) => contexto.tienePermiso(codigo)) : !permiso || contexto.tienePermiso(permiso);
        return autorizado ? true : router.createUrlTree(['/auth/access']);
    } catch {
        return router.createUrlTree(['/auth/access']);
    }
};

export const guestGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const token = await auth.getValidAccessToken();

    return token ? router.createUrlTree(['/']) : true;
};
